import type { Nullable, Paginator } from '@/types'

export function siblings<T extends { id: number }>(
  list: T[],
  current: number
): { prev: Nullable<T>; next: Nullable<T> } {
  const index = list.findIndex((item) => item.id === current)
  const prev = index > 0 ? list[index - 1] : null
  const next = index < list.length - 1 ? list[index + 1] : null
  return { prev, next }
}

export function paginator<T extends { id: number }>(
  list: T[],
  current: number,
  onPrev: (id: number) => void,
  onNext: (id: number) => void
): Nullable<Paginator> {
  const { prev, next } = siblings(list, current)
  let paginator: Nullable<Paginator> = null
  if (prev !== null || next !== null) {
    paginator = {
      prev: prev !== null ? () => onPrev(prev.id) : null,
      next: next !== null ? () => onNext(next.id) : null,
    }
  }
  return paginator
}
